import { ConditionTarget } from 'src/app/components/system/condition-builder/condition-builder.model';

export class PointNPayActivityParameterConfiguration {
  parameterName: string;
  criteria: ConditionTarget[];
}
